import { combineReducers } from 'redux';

import types from './types';

import csModel from 'src/model/ClaimStatus.model';
import DateRangeModel from 'src/model/dateRange.model';
import {
  sortType,
  statusType,
  orderType,
  invoiceType,
  nardType,
  ordernumberType,
  poType
} from 'src/model/modules/claimstatusvw.model';

const data = (
  state: csModel[] = [],
  { type, payload }: { type: string; payload: csModel[] }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_DATA:
      return payload;
    default:
      return state;
  }
};
const datesFilter = (
  state: DateRangeModel = null,
  { type, payload }: { type: string; payload: DateRangeModel }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_DATE_RANGE_FILTER:
      return payload;

    default:
      return state;
  }
};

const sortFilter = (
  state: { type: sortType; order: 'asc' | 'desc' } = null,
  {
    type,
    payload
  }: { type: string; payload: { type: sortType; order: 'asc' | 'desc' } }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_SORT_FILTER:
      return payload;

    default:
      return state;
  }
};

const statusFilter = (
  state: statusType = null,
  { type, payload }: { type: string; payload: statusType }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_STATUS_FILTER:
      return payload;

    default:
      return state;
  }
};

const orderFilter = (
  state: orderType = null,
  { type, payload }: { type: string; payload: orderType }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_ORDER_STATUS_FILTER:
      return payload;

    default:
      return state;
  }
};
const invoiceFilter = (
  state: invoiceType = null,
  { type, payload }: { type: string; payload: invoiceType }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_INVOICE_FILTER:
      return payload;

    default:
      return state;
  }
};

const orderNumberFilter = (
  state: ordernumberType = null,
  { type, payload }: { type: string; payload: ordernumberType }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_ORDER_FILTER:
      return payload;

    default:
      return state;
  }
};
const poNumberFilter = (
  state: poType = null,
  { type, payload }: { type: string; payload: poType }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_PO_FILTER:
      return payload;

    default:
      return state;
  }
};

const pageNumber = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_PAGE_NUMBER:
      return payload;

    default:
      return state;
  }
};

const pageSize = (
  state: number = 0,
  { type, payload }: { type: string; payload: number }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_PAGE_SIZE:
      return payload;

    default:
      return state;
  }
};

const error = (
  state: { caller: string; hasFailed: boolean; message: string } = {
    caller: '',
    hasFailed: false,
    message: ''
  },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_ERROR:
      return payload;

    default:
      return state;
  }
};

const success = (
  state: { hasSucceed: boolean; message: string } = {
    hasSucceed: false,
    message: ''
  },
  { type, payload }: { type: string; payload: any }
) => {
  switch (type) {
    case types.SET_CLAIMSTATUS_SUCCESS:
      return payload;

    default:
      return state;
  }
};

export default combineReducers({
  data,
  datesFilter,
  sortFilter,
  statusFilter,
  orderFilter,
  invoiceFilter,
  orderNumberFilter,
  poNumberFilter,
  pageNumber,
  pageSize,
  error,
  success
});
